import { useFirestore } from "hooks/firestore/v2/useFirestore";
import { userVerifications } from "hooks/firestore/v2/models/userVerifications";

const useUserVerifications = () => {
  const { data, error, isLoading } = useFirestore(
    "/users/{userId}/verifications",
    userVerifications.array(),
  );

  return {
    userVerifications: data,
    error,
    isLoading,
  } as const;
};

export { useUserVerifications };
